// src/composables/useBackBtn.js
import { onMounted, onBeforeUnmount } from 'vue';

const backStack = [];
let initialized = false;

function initGlobalListener() {
  if (initialized) return;
  initialized = true;

  window.addEventListener('popstate', () => {
    const cb = backStack.pop();

    if (cb) {
      // 우리가 쌓아둔 콜백 처리
      cb();
      // ❌ 여기서 pushState / history.back() 안 한다
    } else {
      // 스택 비면, 그냥 라우터/브라우저 기본 동작
      // 아무것도 안 함
    }
  });
}

export function useBackButton(onBack) {
  onMounted(() => {
    initGlobalListener();

    backStack.push(onBack);

    // 이 컴포넌트를 위한 "가짜 히스토리 한 칸" 추가
    history.pushState({ backGuard: true }, '', location.href);
  });

  onBeforeUnmount(() => {
    const idx = backStack.lastIndexOf(onBack);
    if (idx !== -1) {
      backStack.splice(idx, 1);
    }
  });
}
